import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { B2BCheckoutDeliveryAddressComponent } from '@spartacus/checkout/b2b/components'
import { CheckoutCostCenterFacade, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import { CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade } from '@spartacus/checkout/base/root'
import {
  Address,
  GlobalMessageService,
  TranslationService,
  UserAddressService,
  UserCostCenterService
} from '@spartacus/core'
import { Card } from '@spartacus/storefront'
import { Observable, of } from 'rxjs'
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators'
import { BaseCountry } from '../../../models/enum/country.enum'
import { IEtaGuide } from '../../../models/interface/eta-guide.interface'
import { CustomCartService } from '../../../services/custom-cart.service'
import { EtaService } from '../../../services/eta.service'
import { SharedService } from '../../../services/shared/shared.service'

@Component({
    selector: 'app-custom-delivery-address',
    templateUrl: './custom-delivery-address.component.html',
    styleUrls: ['./custom-delivery-address.component.scss'],
    standalone: false
})
export class CustomDeliveryAddressComponent extends B2BCheckoutDeliveryAddressComponent implements OnInit, OnDestroy {
  public etaPanel: boolean
  public EnumCountry = BaseCountry
  public baseSite: string
  etaGuide$: Observable<IEtaGuide>
  public showAddresses: boolean

  constructor(
    protected userAddressService: UserAddressService,
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected activatedRoute: ActivatedRoute,
    protected translationService: TranslationService,
    protected activeCartFacade: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected globalMessageService: GlobalMessageService,
    protected checkoutCostCenterFacade: CheckoutCostCenterFacade,
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    protected userCostCenterService: UserCostCenterService,
    public etaService: EtaService,
    public sharedService: SharedService,
    public customCartService: CustomCartService,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(
      userAddressService,
      checkoutDeliveryAddressFacade,
      activatedRoute,
      translationService,
      activeCartFacade,
      checkoutStepService,
      checkoutDeliveryModesFacade,
      globalMessageService,
      checkoutCostCenterFacade,
      checkoutPaymentTypeFacade,
      userCostCenterService
    )
  }

  ngOnInit(): void {
    this.etaGuide$ = this.etaService.getDeliveryEtaGuide()
    this.baseSite = this.sharedService.baseSiteId

    super.ngOnInit()

    this.setDeliveryMode()
  }

  /**
   * Override OOTB function as Cost Center Dropdown in removed from Delivery Address Checkout Step.
   * Therefore, getting all available cost centers' Addresses.
   * @protected
   */
  protected getSupportedAddresses(): Observable<Address[]> {
    if (this.isAccountPayment) {
      return this.activeCartFacade.getActiveCartId().pipe(
        take(1),
        switchMap((cartId) => {
          return this.customCartService.getConstCenterAddresses(cartId)
        }),
        tap((res) => {
          this.showAddresses = true
          this.changeDetectorRef.detectChanges()
        }),
        catchError((error) => {
          return of([])
        })
      )
    }

    return this.userAddressService.getAddresses()
  }

  addAddress(address: Address | undefined): void {
    if (!address) {
      return
    }

    this.busy$.next(true)
    this.doneAutoSelect = true

    this.checkoutDeliveryAddressFacade
      .createAndSetAddress(address)
      /**
       * Remove invoking clearCheckoutDeliveryMode as Delivery Mode step is excluded from Checkout Steps
       */
      // .pipe(
      //   switchMap(() =>
      //     this.checkoutDeliveryModesFacade.clearCheckoutDeliveryMode()
      //   )
      // )
      .subscribe({
        complete: () => {
          // we don't call onSuccess here, because it can cause a spinner flickering
          this.next()
        },
        error: () => {
          this.onError()
          this.doneAutoSelect = false
        }
      })
  }

  protected setAddress(address: Address): void {
    this.busy$.next(true)
    this.checkoutDeliveryAddressFacade
      .setDeliveryAddress(address)
      // .pipe(
      //   switchMap(() =>
      //     this.checkoutDeliveryModesFacade.clearCheckoutDeliveryMode()
      //   )
      // )
      .subscribe({
        complete: () => {
          this.onSuccess()
        },
        error: () => {
          this.onError()
        }
      })
  }

  protected removeNameFromCard(card: Card): Card {
    if (card && card.textBold) {
      delete card.textBold
    }
    return card
  }

  /**
   * Set Delivery Mode for the cart
   * @protected
   */
  protected setDeliveryMode(): void {
    this.checkoutDeliveryModesFacade
      .getSupportedDeliveryModes()
      .pipe(filter((modes) => modes.length > 0))
      .subscribe((s) => {
        this.checkoutDeliveryModesFacade.setDeliveryMode(s[0].code)
      })
  }
}
